<template>
  <div>
    <el-row style="color: #F56C6C; font-size: 20px; font-weight: bolder;margin-top:20px;">
      <el-col :xl="3" :lg="5" :md="6">
        <span>
          日期：{{ orderDate }}
        </span>
      </el-col>
    </el-row>
    <el-row style="margin-top: 20px;">
      <el-col style="margin-top: 20px;">
        <el-form :inline="true" class="demo-form-inline" :model="searchForm" ref="searchForm" @submit.native.prevent>
          <el-form-item label="产品名称：">
            <el-input size="medium" placeholder="产品名称" @keyup.enter.native="searchFun()" clearable @clear="resetSearch" v-model="searchForm.name"></el-input>
          </el-form-item>
          <el-form-item label="产品编码：">
            <el-input size="medium" placeholder="产品编码" @keyup.enter.native="searchFun()" clearable @clear="resetSearch" v-model="searchForm.code"></el-input>
          </el-form-item>
          <el-form-item label="品牌：">
            <el-input size="medium" placeholder="品牌" @keyup.enter.native="searchFun()" clearable @clear="resetSearch" v-model="searchForm.brand"></el-input>
          </el-form-item>
          <el-button size="medium" type="primary" @click="searchFun()">筛选</el-button>
          <el-button size="medium" @click="oneClickSupplement()">一键补采</el-button>
        </el-form>
      </el-col>
    </el-row>
    <!-- 商品列表-表格形式 -->
    <el-row>
      <el-col :span="24">
        <el-table stripe border :data="mainList" style="width: 100%">
          <el-table-column label="序号" type="index" width="50"></el-table-column>
          <el-table-column label="编码" prop="PRODUCT_CODE" min-width="60"></el-table-column>
          <el-table-column label="名称" prop="PRODUCT_NAME" min-width="130"></el-table-column>
          <el-table-column label="单位" prop="TYPE_UNIT" min-width="60"></el-table-column>
          <el-table-column label="单价" prop="PRICE" min-width="60"></el-table-column>
          <el-table-column label="供应商" prop="VENDOR_NAME" min-width="80"></el-table-column>
          <el-table-column label="购买数量" prop="product_count" min-width="60">
            <template slot-scope="scope">
              <el-input v-model="scope.row.product_count" @keyup.enter.native="addToCart(scope.row)" :disabled="setBtnStatus(scope.row, true, false)"
                clearable></el-input>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" width="100">
            <template slot-scope="scope">
              <el-button size="small" :type="setBtnStatus(scope.row, 'danger', '')" @click="addToCart(scope.row)">
                {{ setBtnStatus(scope.row, '取消', '购买') }}</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <!--进界面的弹框-->
    <el-dialog title="请选择" :visible.sync="isAddBtnToProduct" width="30%" :show-close="false" :close-on-click-modal="false">
      <el-form :model="firstForm" label-width="100px" style="text-align: inherit;margin: 0">
        <el-form-item label="送货日期：">
          <el-date-picker v-model="firstForm.date" type="date" placeholder="选择日期" value-format="yyyy-MM-dd" style="width: 100%"
            :clearable="false"></el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" style="margin-right: 13px" @click="cancel()">取消</el-button>
        <el-button size="small" @click="confirmDeliveryDate()">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  queryDateFun, submitOrderDate, queryProduct, addShoppingCart, deleteProduct,
} from '@/assets/api/purchaseOrderManage';
import http from '@/assets/common/http';
import util from '@/assets/common/util';

export default {
  data() {
    return {
      mainList: [],
      statusList: [],
      searchForm: {},
      firstForm: {
        date: '',
      },
      orderDate: '',
      cartId: '',
    };
  },
  created() {
    this.queryDate();
  },
  computed: {
    isAddBtnToProduct() {
      return this.$store.getters.isAddBtnToProduct;
    },
  },
  methods: {
    resetSearch() {
      this.queryDate();
    },
    // 查看是否存在送货日期
    queryDate() {
      queryDateFun()
        .then((result) => {
          if (result.length !== 0) {
            this.$store.commit('SET_ADD_BTN_TO_PROJECT', false);
            this.orderDate = result[0].ORDER_DATE;
            this.cartId = result[0].ID;
          } else {
            this.$store.commit('SET_ADD_BTN_TO_PROJECT', true);
            this.orderDate = '';
            this.cartId = 0;
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    // 提交下单时间
    confirmDeliveryDate() {
      // 先检测属性是否都正确
      const isExist = this.checkObjectExists(this.firstForm, 'date');
      if (isExist) {
      // 关账限制
        if (this.$util.isOrderClosed(this.firstForm.date)) {
          this.$message.show({ text: '该月份已关账，无法下单', type: 'warning' });
          return false;
        }

        const params = {
          ORDER_DATE: this.firstForm.date,
        };
        submitOrderDate(params)
          .then((result) => {
            this.queryDate();
            this.$store.commit('SET_ADD_BTN_TO_PROJECT', false);
            this.cartId = result[0].ID;
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
          });
      }
    },
    // 检测指定对象中的属性是否存在并不为空
    checkObjectExists(obj, key) {
      let isExist = true;
      if (!(key in obj) || obj[key] === '') {
        this.$message.show({ text: '请选择日期', type: 'warning' });
        isExist = false;
      }
      return isExist;
    },
    //  点击筛选按钮触发
    searchFun() {
      const params = {
        ORDER_DATE: this.orderDate,
      };
      if (this.searchForm.name) {
        params.PRODUCT_NAME = this.searchForm.name;
      }
      if (this.searchForm.code) {
        params.PRODUCT_CODE = this.searchForm.code;
      }
      if (this.searchForm.brand) {
        params.PRODUCT_NAME = this.searchForm.brand;
      }
      queryProduct(params).then((result) => {
        if (result.length !== 0) {
          this.mainList = result.map((item) => Object.assign(item, { PRODUCT_CODE: item.PRODUCT_CODE.toString() }));
        } else {
          this.mainList = [];
          this.$message.show({ text: '暂无数据', type: 'success' });
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 一键补采：拉取常购产品列表（复用查询商品接口，IS_FREQUENT 条件）
    oneClickSupplement() {
      queryProduct({ ORDER_DATE: this.orderDate, IS_FREQUENT: 1 })
        .then((result) => {
          if (result.length !== 0) {
            this.mainList = result.map((item) => Object.assign(item, { PRODUCT_CODE: item.PRODUCT_CODE.toString() }));
          } else {
            this.mainList = [];
            this.$message.show({ text: '暂无常购产品', type: 'warning' });
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    filterStatusList(statusItem) {
      return this.statusList.filter((item) => item.PRODUCT_CODE === statusItem.PRODUCT_CODE && item.VENDOR_ID === statusItem.VENDOR_ID);
    },
    // -------------加入购物车
    async addToCart(row) {
      const statusItem = { PRODUCT_CODE: row.PRODUCT_CODE, product_count: Number(row.product_count), VENDOR_ID: row.VENDOR_ID };
      if (!util.JudgmentUnit(row.TYPE_UNIT)) {
        const isInteger = (row.product_count % 1 === 0);
        if (!isInteger) {
          this.$message.show({ text: '单位不是公斤的，只能输入整数', type: 'error' });
          return false;
        }
      }
      if (row.product_count !== undefined) {
        const products = this.filterStatusList(statusItem);
        if (products.length === 0) {
          // 添加购物车成功
          const params1 = {
            SERVICE_ID: '15066',
            OTYPE: 13,
            GYS_ID: Number(sessionStorage.getItem('tcId')),
            SUPPLIER_ID: row.SUPPLIER_ID,
            PRODUCT_CODE: row.PRODUCT_CODE,
          };
          let TAX_RATE = 0; let flag = false;
          await http.post(params1).then((res) => {
            TAX_RATE = res[0].TAX_RATE;
          }).catch((err) => {
            this.$message.show({ text: err, type: 'error' });
            flag = true;
          });
          if (flag) {
            return false;
          }
          const params2 = {
            CART_ID: Number(this.cartId),
            VENDOR_ID: row.VENDOR_ID,
            PRODUCT_CODE: row.PRODUCT_CODE,
            PRICE: Number(row.PRICE),
            PRODUCT_COUNT: Number(row.product_count),
            TAX_RATE,
            BEFORE_TAX_PRICE: Math.round((Number(row.PRICE) / (1 + TAX_RATE / 100)) * 100) / 100,
          };
          addShoppingCart(params2).then((res) => {
            this.statusList.push(statusItem);
          }).catch((err) => {
            this.$message.show({ text: err, type: 'error' });
          });
        } else {
          this.removeItemFromArray(this.statusList, ...products);
          this.removeProductFromServer(...products);
        }
      }
    },

    // 从服务器上删除添加购物车的产品
    removeProductFromServer(product) {
      const params = {
        PRODUCT_CODE: product.PRODUCT_CODE,
      };
      deleteProduct(params).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },
    // 从数组中移除指定项
    removeItemFromArray(arr, target) {
      arr.forEach((product, index) => {
        if (product.PRODUCT_CODE === target.PRODUCT_CODE && product.VENDOR_ID === target.VENDOR_ID) {
          arr.splice(index, 1);
        }
      });
    },
    /**
     * @param clickStatus：点击后的显示状态
     * @param normalStatus 正常的显示状态
     */
    setBtnStatus(row, clickStatus, normalStatus) {
      const products = this.filterStatusList(row);
      if (products.length !== 0) {
        this.mainList.forEach((item) => {
          if (item.PRODUCT_CODE === products[0].PRODUCT_CODE && row.VENDOR_ID === products[0].VENDOR_ID) {
            item.product_count = products[0].product_count;
          }
        });
        return clickStatus;
      }
      return normalStatus;
    },

    // 首页模态框点击取消触发
    cancel() {
      this.$router.back();
    },
  },
  beforeDestroy() {
    this.$store.commit('SET_ADD_BTN_TO_PROJECT', true);
  },
};
</script>
<style scoped>
.el-table .cell {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/shopOrderManage/purchaseAddProduct.vue